export const rounding = {
	md: 16,
	sm: 8,
};
